{{#if fileUploads.length}}
<ul class="fileUpload-progress">
    {{#each fileUploads}}
        {{#unless complete}}
            <li class="fileUpload-progress-file js-element--fileUploadProgress" data-item-id="{{id}}">
                <div>{{name}}</div>
                <a href="" class="fileUpload-progress-file-cancel js-action--cancelFileUpload">Cancel</a>
                <div><span class="lbl lbl_bold lbl_brand">{{truncateNumber percent}}% uploaded</span><span> [ {{convertBytes loaded}}</span>/<span>{{convertBytes total}} ]</span></div>
                <div class="fileUpload-progress-file-info">
                    <div class="fileUpload-progress-file-info-loaded" style="width: {{percent}}%;"></div>
                </div>
            </li>
        {{/unless}}
    {{/each}}
</ul>
{{/if}}
